module.exports = __webpack_public_path__ + "a1017de6f2cc2b1e35a3467a5ca19725.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/videos/spot-color.jpg
// module id = 143
// module chunks = 0